module.exports = __webpack_public_path__ + "static/media/logo-perk.9c69cc9b.svg";